import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  propertyScheduledForVisitData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  propertyToBeAuditedData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  propertyBookedForVisitList: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  propertyIdToSetAppointment: {
    items: [],
  },
  timeSlotData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  propertyScheduledForAuditedData: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  appointmentsList: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  myVisitsAppointmentList: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  myAgentsList: {
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  myCommissionList:{
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
  myAuditCommissionList:{
    error: {
      isError: false,
      message: "",
    },
    items: [],
    loading: false,
  },
};

export const agentDashboardSlice = createSlice({
  name: "agentDashboardData",
  initialState,
  reducers: {
    setPropertyToBeAuditedData: (state, action) => {
      state.propertyToBeAuditedData.items = action.payload;
    },
    setPropertyToBeAuditedDataLoading: (state, action) => {
      state.propertyToBeAuditedData.loading = action.payload;
    },
    setPropertyToBeAuditedDataError: (state, action) => {
      state.propertyToBeAuditedData.error = action.payload;
      state.propertyToBeAuditedData.items = [];
    },
    setPropertyScheduledForVisitData: (state, action) => {
      state.propertyScheduledForVisitData.items = action.payload;
    },
    setPropertyScheduledForVisitDataLoading: (state, action) => {
      state.propertyScheduledForVisitData.loading = action.payload;
    },
    setPropertyScheduledForVisitDataError: (state, action) => {
      state.propertyScheduledForVisitData.error = action.payload;
      state.propertyScheduledForVisitData.items = [];
    },
    setPropertyScheduledForAuditedData: (state, action) => {
      state.propertyScheduledForAuditedData.items = action.payload;
    },
    setPropertyScheduledForAuditedDataLoading: (state, action) => {
      state.propertyScheduledForAuditedData.loading = action.payload;
    },
    setPropertyScheduledForAuditedDataError: (state, action) => {
      state.propertyScheduledForAuditedData.error = action.payload;
      state.propertyScheduledForAuditedData.items = [];
    },
    setPropertyBookedForVisitList: (state, action) => {
      state.propertyBookedForVisitList.items = action.payload;
    },
    setPropertyBookedForVisitListLoading: (state, action) => {
      state.propertyBookedForVisitList.loading = action.payload;
    },
    setPropertyBookedForVisitListError: (state, action) => {
      state.propertyBookedForVisitList.error = action.payload;
      state.propertyBookedForVisitList.items = [];
    },
    setSelectedPropertyIdToSetAppointment: (state, action) => {
      state.propertyIdToSetAppointment.items = action.payload;
    },
    setTimeSlotDataListLoading: (state, action) => {
      state.timeSlotData.loading = action.payload;
    },
    setTimeSlotDataListError: (state, action) => {
      state.timeSlotData.error = action.payload;
      state.timeSlotData.items = [];
    },
    setTimeSlotDataList: (state, action) => {
      state.timeSlotData.items = action.payload;
    },
    setListOfAppointmentsLoading: (state, action) => {
      state.appointmentsList.loading = action.payload;
    },
    setListOfAppointmentsError: (state, action) => {
      state.appointmentsList.error = action.payload;
      state.appointmentsList.items = [];
    },
    setListOfAppointments: (state, action) => {
      state.appointmentsList.items = action.payload;
    },
    setMyPropertyVisitsListLoading: (state, action) => {
      state.myVisitsAppointmentList.loading = action.payload;
    },
    setMyPropertyVisitsListError: (state, action) => {
      state.myVisitsAppointmentList.error = action.payload;
      state.myVisitsAppointmentList.items = [];
    },
    setMyPropertyVisitsList: (state, action) => {
      state.myVisitsAppointmentList.items = action.payload;
    },

    setMyAgentsListLoading: (state, action) => {
      state.myAgentsList.loading = action.payload;
    },
    setMyAgentsListError: (state, action) => {
      state.myAgentsList.error = action.payload;
      state.myAgentsList.items = [];
    },
    setMyAgentsList: (state, action) => {
      state.myAgentsList.items = action.payload;
    },
    setMyCommissionSaleListLoading: (state, action) => {
      state.myCommissionList.loading = action.payload;
    },
    setMyCommissionSaleListError: (state, action) => {
      state.myCommissionList.error = action.payload;
      state.myCommissionList.items = [];
    },
    setMyCommissionSaleList: (state, action) => {
      state.myCommissionList.items = action.payload;
    },
    setMyCommissionAuditListLoading: (state, action) => {
      state.myAuditCommissionList.loading = action.payload;
    },
    setMyCommissionAuditListError: (state, action) => {
      state.myAuditCommissionList.error = action.payload;
      state.myAuditCommissionList.items = [];
    },
    setMyCommissionAuditList: (state, action) => {
      state.myAuditCommissionList.items = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setPropertyScheduledForVisitData,
  setPropertyScheduledForVisitDataLoading,
  setPropertyScheduledForVisitDataError,
  setPropertyBookedForVisitList,
  setPropertyBookedForVisitListLoading,
  setPropertyBookedForVisitListError,
  setSelectedPropertyIdToSetAppointment,
  setTimeSlotDataListLoading,
  setTimeSlotDataListError,
  setTimeSlotDataList,
  setPropertyScheduledForAuditedData,
  setPropertyScheduledForAuditedDataLoading,
  setPropertyScheduledForAuditedDataError,
  setPropertyToBeAuditedData,
  setPropertyToBeAuditedDataError,
  setPropertyToBeAuditedDataLoading,
  setListOfAppointments,
  setListOfAppointmentsError,
  setListOfAppointmentsLoading,
  setMyPropertyVisitsListLoading,
  setMyPropertyVisitsListError,
  setMyPropertyVisitsList,
  setMyAgentsListLoading,
  setMyAgentsListError,
  setMyAgentsList,
  setMyCommissionSaleList,
  setMyCommissionSaleListError,
  setMyCommissionSaleListLoading,
  setMyCommissionAuditList,
  setMyCommissionAuditListLoading,
  setMyCommissionAuditListError
} = agentDashboardSlice.actions;

export default agentDashboardSlice.reducer;

export const agentDashboardSelector = (state) => state.agentDashboardData;
